var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5376 12.9231C59.5376 19.4215 54.7006 24.8122 48.4606 25.6986L34.9836 18.4615C34.1345 16.8 33.6914 14.9168 33.6914 12.9231C33.6914 5.79692 39.4883 0 46.6145 0C53.7406 0 59.5376 5.79692 59.5376 12.9231Z",
    fill: "#8DD8A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4609 25.699V44.3081C48.4609 46.3388 46.7994 48.0004 44.7686 48.0004H4.15325C2.12248 48.0004 0.460938 46.3388 0.460938 44.3081V22.1542C0.460938 20.1235 2.12248 18.4619 4.15325 18.4619H34.9839L48.4609 25.699Z",
    fill: "#B3E5C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15234 40.6152H11.537V44.3075H4.15234V40.6152Z",
    fill: "#67CB85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2305 40.6152H22.6151V44.3075H15.2305V40.6152Z",
    fill: "#67CB85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2293 29.5379V25.8456H18.9216V22.1533H4.15234V25.8456H7.84465V29.5379H4.15234V33.2302H18.9216V29.5379H15.2293Z",
    fill: "#67CB85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3047 40.6152H33.6893V44.3075H26.3047V40.6152Z",
    fill: "#67CB85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3828 40.6152H44.7674V44.3075H37.3828V40.6152Z",
    fill: "#67CB85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4614 22.1542V25.699C47.8708 25.8096 47.2428 25.8465 46.6153 25.8465C41.483 25.8465 37.0154 22.8188 34.9844 18.4619H44.7691C46.7999 18.4619 48.4614 20.1235 48.4614 22.1542Z",
    fill: "#67CB85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0716 7.14746L44.7685 13.4506L42.1577 10.8398L39.5469 13.4506L44.7685 18.6722L53.6824 9.75827L51.0716 7.14746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAdded);
export default __webpack_public_path__ + "static/media/cardAdded.4af3221e15f71fcbbdb123fc0cfe9033.svg";
export { ForwardRef as ReactComponent };